var map = {
	"./AssignTagTruck.png": 2895,
	"./ZoneMapImageIcon.png": 2896,
	"./assetSummary.png": 2897,
	"./barChart.png": 2898,
	"./battery.png": 2899,
	"./batteryExchange.png": 2900,
	"./batteryLevel.png": 2901,
	"./cages.png": 2902,
	"./deployment.png": 2903,
	"./distribution.png": 2904,
	"./favouriteAssets.png": 2905,
	"./favouritePeople.png": 2906,
	"./favouriteZone.png": 2907,
	"./floorplan.png": 2908,
	"./guage.png": 2909,
	"./hours.png": 2910,
	"./lifecycle.png": 2911,
	"./lineChart.png": 2912,
	"./map.png": 2913,
	"./peopleSummary.png": 2914,
	"./recentItem.png": 2915,
	"./zoneSummary.png": 2916,
	"./zonemap.png": 2917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;